/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control[_ngcontent-%COMP%]:active, .form-control[_ngcontent-%COMP%]:focus{border:1px solid;border-color:#b5c6ea!important;background:#f3f5f8}.is-valid[_ngcontent-%COMP%]{border:1px solid;border-color:#b5eada!important;background:#e6f8f2}.is-invalid[_ngcontent-%COMP%]{border-color:#fec3d7!important;background:#feebf1;box-shadow:none!important}"];
export { styles as styles };
